<div class="radio-button-list">
    <label ng-repeat="opt in $ctrl.options track by $index" for="{{opt.id}}">
        <input id="{{opt.id}}" name="{{$ctrl.groupName}}" ng-model="$ctrl.selected" ng-value="opt.value" type="radio">{{opt.text}}
    </label>
</div>